import { Objetivo } from './objetivo';

export class Indicadores{
    idIndicador:number;
	nome:String;
	objetivo:Objetivo;
	usuarioAlteracao:number;
	dataFim:Date;
	dataInicio:Date;


}